// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/info/general-info.scss
// module id = 470
// module chunks = 0